export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const uid = () => typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

// Value categories for HEOR tab
export const VALUE_CATEGORIES = [
  { id: "longer_survival", label: "Longer survival" },
  { id: "slower_progression", label: "Slower disease progression" },
  { id: "quality_of_life", label: "Better quality of life" },
  { id: "fewer_ae", label: "Fewer adverse events" },
  { id: "easier_admin", label: "Easier treatment administration" },
  { id: "fewer_visits", label: "Fewer hospital visits" },
  { id: "reduced_monitoring", label: "Reduced monitoring" },
  { id: "reduced_caregiver", label: "Reduced caregiver burden" },
  { id: "avoided_costs", label: "Avoided later treatment costs" },
  { id: "high_need_subgroup", label: "Benefit in a high-need subgroup" },
];

// Cautionary tales — one per tab, shown on the right column of each tab
export const CAUTIONARY_TALES = {
  clinical_proof: {
    title: "Exubera",
    body: "Pfizer's inhaled insulin offered a genuinely novel route of administration and was approved by both the FDA and EMA. But clinicians and patients did not see enough benefit over injectable insulin, uptake collapsed, and NICE did not recommend it because superiority in clinical or cost effectiveness over existing treatments was not established.",
    lesson: "A different route of administration or scientific novelty alone will not create value. The clinical proof must be defined against what patients and clinicians already use — not against 'no treatment'.",
  },
  regulatory_route: {
    title: "Vorasidenib",
    body: "Vorasidenib showed a striking progression-free survival benefit in low-grade glioma and secured FDA approval. But the community remained unsure whether progression-free survival translated into a meaningful overall survival benefit worth the safety and cost trade-offs — a debate that continues to shape reimbursement.",
    lesson: "Endpoint choice is not just a scientific decision. The endpoint must support every downstream decision the regulator, clinician, HTA body and payer will make. An endpoint that convinces one audience but not the others creates a fragile approval.",
  },
  access_heor: {
    title: "Zynteglo",
    body: "Bluebird's gene therapy for beta-thalassemia was approved in the EU but withdrawn from the European market in 2021 after failing to agree reimbursement — its long-term durability claims underpinned a price the European HTA bodies would not accept. The same product later gained a very different commercial trajectory in the US.",
    lesson: "A transformative therapy may still fail commercially if its price depends on long-term benefits that have not yet been demonstrated over a sufficient period. The economic case must be tested against the payer's actual evidentiary bar — not the founder's optimism.",
    extra: "Framing matters: the SAME product mapped against three populations (all patients / only those who failed previous treatment / a specific complication) can produce three completely different value stories — different unmet need, comparator, trial design, price and evidence bar. Patient selection is also an economic decision.",
  },
};

// Evidence-need seed rows for Payer Evidence Gaps
export const EVIDENCE_TEMPLATE = [
  { what: "Meaningful clinical benefit",         who: "Regulator / clinician / payer", have: "no" },
  { what: "Benefit compared with current care",  who: "Clinician / payer",             have: "no" },
  { what: "Long-term or durable effect",         who: "Regulator / payer",             have: "no" },
];
export const HAVE_OPTIONS = ["yes", "partial", "no"];

// Evidence type suggestions
export const EVIDENCE_TYPES = [
  "Clinical efficacy", "Safety", "Patient-reported outcomes", "Quality of life",
  "Duration of benefit", "Healthcare-resource use", "Hospitalisation or treatment avoidance",
  "Caregiver burden", "Comparison with standard care", "Evidence in the intended subgroup",
];

// Regulatory pathway options
export const REG_AGENCIES = ["FDA", "EMA", "MHRA (UK)", "PMDA (Japan)", "Multiple"];
export const REG_PATHWAYS = [
  "Standard",
  "FDA Fast Track",
  "FDA Breakthrough",
  "FDA Accelerated Approval",
  "FDA RMAT (Regenerative Medicine Advanced Therapy)",
  "EMA PRIME",
  "EMA Conditional Marketing Authorisation",
  "EMA Adaptive Pathways",
  "MHRA ILAP",
  "Orphan (FDA / EMA)",
  "Paediatric Investigation Plan / PSP",
];
export const PRODUCT_TYPES = [
  "Small molecule",
  "Biologic (mAb / protein / peptide)",
  "Gene therapy",
  "Cell therapy",
  "ATMP (EMA-classified)",
  "RNA therapy (mRNA / ASO / siRNA)",
  "Vaccine",
  "Medical device",
  "Combination product",
  "Diagnostic",
  "Digital therapeutic",
];
